// extracted by mini-css-extract-plugin
export var attachment = "_qr-a";
export var emailContainer = "_qr-4";
export var emailContentPaddedContainer = "_qr-b";
export var emailHeader = "_qr-6";
export var emailIframe = "_qr-3";
export var emailInfoIcon = "_qr-9";
export var emailShortenedSummary = "_qr-e";
export var infoDropdown = "_qr-0";
export var infoRowBoundedContent = "_qr-d";
export var internal = "_qr-5";
export var merchant = "_qr-8";
export var messageInputContainer = "_qr-h";
export var normal = "_qr-7";
export var replyCard = "_qr-f";
export var subtleButton = "_qr-1";
export var subtleButtonIconContainer = "_qr-2";
export var toggleViewRepliesButton = "_qr-c";
export var wrappingText = "_qr-g";